import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AgentService, AgentDto } from '../../../services/agent.service';
import { ExternalDataService, PricingGroup } from '../../../services/externalDataService.service';

@Component({
  selector: 'app-assign-agent-pricing-group',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './assign-agent-pricing-group.component.html',
  styleUrl: './assign-agent-pricing-group.component.css'
})
export class AssignAgentPricingGroupComponent implements OnInit {
  @Input() agent!: AgentDto;
  @Output() pricingGroupAssigned = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  pricingGroups: PricingGroup[] = [];
  selectedGroupId: string = '';
  isSubmitting = false;
  isLoadingGroups = false;
  errors: { [key: string]: string } = {};

  constructor(
    private agentService: AgentService,
    private externalDataService: ExternalDataService
  ) {}

  ngOnInit(): void {
    this.selectedGroupId = this.agent.pricingGroupId || '';
    this.loadPricingGroups();
  }

  loadPricingGroups(): void {
    this.isLoadingGroups = true;
    this.externalDataService.getPricingGroups().subscribe({
      next: (groups) => {
        this.pricingGroups = groups;
        this.isLoadingGroups = false;
      },
      error: (error) => {
        console.error('Error loading pricing groups:', error);
        this.isLoadingGroups = false;
      }
    });
  }

  onSubmit(): void {
    this.isSubmitting = true;
    this.errors = {};

    if (!this.selectedGroupId) {
      // Clear assignment
      this.agentService.removeAgentPricingGroup(this.agent.agentId).subscribe({
        next: () => {
          this.pricingGroupAssigned.emit();
          this.closeModal.emit();
        },
        error: (err) => {
          console.error('Error clearing pricing group:', err);
          this.errors['general'] = 'Failed to clear pricing group assignment. Please try again.';
          this.isSubmitting = false;
        }
      });
    } else {
      // Assign pricing group
      this.agentService.assignAgentPricingGroup({
        agentId: this.agent.agentId,
        pricingGroupId: this.selectedGroupId
      }).subscribe({
        next: () => {
          this.pricingGroupAssigned.emit();
          this.closeModal.emit();
        },
        error: (err) => {
          console.error('Error assigning pricing group:', err);
          this.errors['general'] = 'Failed to assign pricing group. Please try again.';
          this.isSubmitting = false;
        }
      });
    }
  }

  getPricingGroupName(pricingGroupId?: string): string {
    if (!pricingGroupId || pricingGroupId === 'null' || pricingGroupId === 'undefined') return 'Global';
    const group = this.pricingGroups.find(g => g.id === pricingGroupId);
    return group ? group.name : pricingGroupId;
  }

  onCancel(): void {
    this.closeModal.emit();
  }
}
